import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import OpenInNewSharpIcon from '@gamma/ui/icons/OpenInNewSharpIcon';
import { Panel, PanelHeader } from '@gamma/ui/layout';
import { RouterLink } from '@gamma/ui/navigation';
import { ROUTES } from '../../../../../shared/constants';
import { i18n } from '../../../../../shared/localization';
import { ChatGPTIcon } from '../../../../entities/components';

const {
  enableGPTIntegrationContent,
  enableGPTIntegrationTitle,
  enableGPTPrivateData,
} = i18n.pages.integrations.chatGPT;
const { systemSettingsIntegrationsConfig } = ROUTES;

export const EnableGPT = () => {
  return (
    <Panel>
      <PanelHeader divider>
        <HStack>
          <ChatGPTIcon boxSize={5} />{' '}
          <Text textStyle="h5">{enableGPTIntegrationTitle}</Text>
        </HStack>
      </PanelHeader>
      <VStack alignItems="start">
        <Text textStyle="body-md" color="text.secondary">
          {enableGPTIntegrationContent}
        </Text>
        <Button
          as={RouterLink}
          variant="solid"
          colorScheme="blue"
          mt={2}
          data-testid="chat-gpt-is-disabled-button"
          rightIcon={<OpenInNewSharpIcon />}
          to={systemSettingsIntegrationsConfig}
          target="_blank"
        >
          {enableGPTPrivateData}
        </Button>
      </VStack>
    </Panel>
  );
};
